<template>
  <basic-container id="withdrawal-applyFor20220622">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="searchForm"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="billDateSearch">
        <el-date-picker
          v-model="searchForm.billDateCopy"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </template>
      <template slot="menuLeft"> 可提现金额:{{ tool.money_format(totalFee) }}元 </template>
      <template slot="totalSettlementFeeForm">
        <div>{{ tool.money_format(form.totalSettlementFee) }} 元</div>
      </template>
      <template slot="withdrawAmountForm">
        <div>
          <div style="display: flex">
            <el-input
              style="margin-right: 20px"
              v-model="form.totalSettlementFee"
              disabled
              placeholder="请输入 提现金额"
            ></el-input>
          </div>
          <div style="margin-top: 20px">
            <span style="margin-right: 30px">
              手续费{{ tool.money_format(form.totalCounterFee) }}元
            </span>
            <span> 到账金额{{ tool.money_format(form.totalEnterFee) }}元 </span>
          </div>
        </div>
      </template>
      <template slot="withdrawChannelCopyForm">
        <div>
          <el-radio v-model="withdrawChannel" :label="2">支付宝</el-radio>
          <span>{{ account }}</span>
        </div>
      </template>
      <template slot="settlementFee" slot-scope="scope">
        {{ tool.money_format(scope.row.settlementFee) }}
      </template>
      <template slot="counterFee" slot-scope="scope">
        {{ tool.money_format(scope.row.counterFee) }}
      </template>
      <template slot="enterFee" slot-scope="scope">
        {{ tool.money_format(scope.row.enterFee) }}
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, add, getTransferConfig } from '@/api/v4ward/carv2/financial.js';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
export default {
  data() {
    return {
      form: {
        attachIdList: [],
      },
      searchForm: {},
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      totalFee: '',
      withdrawChannel: 2,
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        searchMenuSpan: 6,
        selection: true,
        stripe: true,
        dialogClickModal: false,
        addBtnText: '提 现',
        addTitle: '提 现',
        menuWidth: 100,
        dialogWidth: '35%',
        menu: false,
        column: [
          {
            label: '账单日期',
            prop: 'billDate',
            search: true,
            searchSpan: 12,
            display: false,
            searchslot: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入到账时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单金额',
            prop: 'settlementFee',
            display: false,
            showWordLimit: true,
            align: 'right',
            slot: true,
            rules: [
              {
                required: true,
                message: '请输入提现单号',
                trigger: 'change',
              },
            ],
          },

          {
            label: '交易金额',
            prop: 'totalSettlementFee',
            maxlength: 12,
            showColumn: false,
            formslot: true,
            row: true,
            span: 24,
            showWordLimit: true,
          },
          {
            label: '提现金额',
            prop: 'withdrawAmount',
            maxlength: 12,
            formslot: true,
            showColumn: false,
            span: 24,
            showWordLimit: true,
          },
          {
            label: '提现到',
            prop: 'withdrawChannelCopy',
            type: 'radio',
            showColumn: false,
            formslot: true,
            span: 24,

            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '到账金额',
            prop: 'enterFee',
            maxlength: 12,
            display: false,
            align: 'right',
            slot: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入到账金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '手续费',
            prop: 'counterFee',
            maxlength: 12,
            display: false,
            align: 'right',
            slot: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入到账金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单状态',
            prop: 'status',
            type: 'select',
            dataType: 'string',
            display: false,

            search: true,
            dicUrl: '/api/blade-system/dict/dictionary?code=tempcar_fee_pay_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择提现状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '申请原因',
            prop: 'description',
            type: 'input',
            span: 24,
            dataType: 'string',
            maxlength: 150,
            showColumn: false,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请选择申请原因',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      account: '',
      payee: '',
      data: [],
      passCloseDialog: false,
      temProjectId: '',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carwithdrawal_applyFor_add, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    let tenantId = this.vdui.getSession('setting').tenantId;
    getTransferConfig({ tenantId }).then((res) => {
      this.payee = res.data.payee;
      this.account = res.data.account;
    });

    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[3].$el.addEventListener('click', () => {
          if (this.option.height == this.bodyHeight - 370) {
            this.option.height = this.bodyHeight - 274;
          } else {
            this.option.height = this.bodyHeight - 370;
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
    this.option.height = this.bodyHeight - 370;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$refs.crud.$refs.table.doLayout();
    });
  },
  methods: {
    outNumber(e, max = 100) {
      let value = e;
      value = value.replace(/[^\d.]/g, ''); //清除“数字”和“.”以外的字符
      value = value.replace(/\.{2,}/g, '.'); //只保留第一个. 清除多余的
      value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }

      if (value == '.') {
        value = '0.';
      }
      if (Number(value) > Number(max)) {
        value = max;
      }
      return value;
    },
    beforeClose(done, type) {
      if (this.passCloseDialog) {
        done();
      } else {
        this.$confirm('确定关闭页面?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            done();
          })
          .then(() => {});
      }
    },
    rowSave(row, loading, done) {
      if (row.totalEnterFee < 1) {
        this.$message.error('到账金额低于1.00元不允申请！');
        done();
        return;
      }

      let form = {
        ids: this.ids,
        accountId: row.accountId,
        totalSettlementFee: row.totalSettlementFee,
        totalCounterFee: row.totalCounterFee,
        totalEnterFee: row.totalEnterFee,
        remark: row.description,
        account: this.account,
        payee: this.payee,
      };
      add(form).then(
        () => {
          this.passCloseDialog = true;
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    beforeOpen(done, type) {
      console.log(this.selectionList);
      let openFlag = true;
      if (this.selectionList.length < 1) {
        this.$message({
          message: '请选择提现账单！',
          type: 'warning',
        });
        return;
      }
      let totalSettlementFee = 0;
      let totalCounterFee = 0;
      let totalEnterFee = 0;
      this.selectionList.forEach((ele) => {
        if (ele.status !== 0) {
          openFlag = false;
        }
        totalSettlementFee += Number(ele.settlementFee);
        totalCounterFee += Number(ele.counterFee);
        totalEnterFee += Number(ele.enterFee);
      });
      if (!openFlag) {
        this.$message({
          message: '请选择账单状态为待申请状态的账单！',
          type: 'warning',
        });
        return;
      }
      this.form = {
        totalSettlementFee: totalSettlementFee.toFixed(2),
        totalCounterFee: totalCounterFee.toFixed(2),
        totalEnterFee: totalEnterFee.toFixed(2),
        remark: '',
      };

      if (type === 'view') {
        this.viewFlag = true;
        this.passCloseDialog = true;
      } else {
        this.passCloseDialog = false;
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.searchForm = {};
      this.searchForm.accountId = this.temAccountId;
      this.query.accountId = this.temAccountId;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;

      this.loading = true;
      // console.log(this.query.billDateCopy)
      if (this.query.billDateCopy) {
        this.query.searchStartBillDate = this.dayjs(this.query.billDateCopy[0]).format(
          'YYYY-MM-DD'
        );
        this.query.searchEndBillDate = this.dayjs(this.query.billDateCopy[1]).format('YYYY-MM-DD');
      }
      // this.temAccountId = this.query.accountId;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          let tempcarFeePayIPage = data.tempcarFeePayIPage;
          this.page.total = tempcarFeePayIPage.total;
          this.data = tempcarFeePayIPage.records;
          this.loading = false;
          this.totalFee = data.totalFee;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style>
#withdrawal-applyFor20220622 .avue-form__menu--center {
  text-align: right;
}
</style>
<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
